import React, { useState, useEffect, useCallback } from "react";
import "../../../../../Assets/Styles/TableFilter.scss";

// This is a small UI element used in the headers of data tables where the displayed name label has
// a sort filter functionality. It has an initial active filter which is the arrow down, and on clicking
// the filter name the active state classname is added to the arrow icon. IDs are generated based
// on a property passed down from parent to this component (Name property)

const TableFilter = (props) => {
  const [DownIsActive, setDownIsActive] = useState(true);
  useEffect(() => {
    if (props.IsActive && !props.NoPointers) {
      document
        .getElementById(props.Id + "-pointer-down")
        .classList.add("active-filter");
    }
  }, [props.Name]);
  const applySortFilter = useCallback(() => {
    if (!props.NoPointers) {
      setDownIsActive(!DownIsActive);
      if (DownIsActive) {
        document
          .getElementById(props.Id + "-pointer-up")
          .classList.add("active-filter");
        document
          .getElementById(props.Id + "-pointer-down")
          .classList.remove("active-filter");
        props.ChangeEvent();
      } else {
        document
          .getElementById(props.Id + "-pointer-up")
          .classList.remove("active-filter");
        document
          .getElementById(props.Id + "-pointer-down")
          .classList.add("active-filter");
        props.ChangeEvent();
      }
    }
  }, [DownIsActive, props.Name]);
  return (
    <div
      className={props.className}
      id={props.Id}
      onClick={() => applySortFilter()}
    >
      <p className="sort-name">{props.Name}</p>
      <div className="section-icon table-filter">
        {props.NoPointers ? null : (
          <React.Fragment>
            <i id={props.Id + "-pointer-up"} className="feather-chevron-up"></i>
            <i
              id={props.Id + "-pointer-down"}
              className="feather-chevron-down"
            ></i>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};
export default TableFilter;
